export const verificarStringVazia = (str: string): string => {
    return str && str.trim().length > 0 ? str : "-";
}

export const quebrarIdTituloString = (input: string) => {
    const regex = /^([^-/]+)-([^/]+)\/(.+)$/;
    const match = input.match(regex);

    if (match) {
        const [_, tipo, num, seq] = match;
        return { tipo, num, seq };
    }

    if (input.length === 3) {
        return { tipo: input, num: "", seq: "" };
    }

    if (input.length === 2) {
        return { tipo: "", num: "", seq: input };
    }

    return { tipo: "", num: input, seq: "" };
};

export const validarCpfCnpj = (documento: string): boolean => {
    const cpfRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
    const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;

    if (cpfRegex.test(documento)) {
        const cpf = documento.replace(/\D/g, '');
        if (cpf.length !== 11) return false;

        // Verifica se todos os dígitos são iguais (CPF inválido)
        if (/^(\d)\1{10}$/.test(cpf)) {
            return false;
        }

        let soma = 0;
        let resto;

        for (let i = 1; i <= 9; i++) {
            soma += parseInt(cpf.charAt(i - 1)) * (11 - i);
        }
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.charAt(9))) return false;

        soma = 0;
        for (let i = 1; i <= 10; i++) {
            soma += parseInt(cpf.charAt(i - 1)) * (12 - i);
        }
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.charAt(10))) return false;

        return true;
    } 
    
    if (cnpjRegex.test(documento)) {
        const cnpj = documento.replace(/\D/g, '');
        if (cnpj.length !== 14) return false;

        let soma = 0;
        let peso = 5;

        for (let i = 0; i < 12; i++) {
            soma += parseInt(cnpj.charAt(i)) * peso;
            peso = peso === 2 ? 9 : peso - 1;
        }
        let resto = soma % 11;
        if (resto < 2) resto = 0; else resto = 11 - resto;
        if (resto !== parseInt(cnpj.charAt(12))) return false;

        soma = 0;
        peso = 6;
        for (let i = 0; i < 13; i++) {
            soma += parseInt(cnpj.charAt(i)) * peso;
            peso = peso === 2 ? 9 : peso - 1;
        }
        resto = soma % 11;
        if (resto < 2) resto = 0; else resto = 11 - resto;
        if (resto !== parseInt(cnpj.charAt(13))) return false;

        return true;
    }

    return false;
}

export const removeEmptyStrings = (obj: Record<string, any>) => {
    return Object.fromEntries(
        Object.entries(obj).filter(([_, value]) => {
            if (typeof value === 'string') return value !== '';
            return value !== null && value !== undefined;
        })
    );
};